import Vue from 'vue'
import App from './App.vue'
import Order from './Order.vue'
import Contacts from './Contacts.vue'
import EmailConfirmation from './EmailConfirmation.vue'
import AdditionalInformation from './AdditionalInformation.vue'
import OrderConfirmation from './OrderConfirmation.vue'
import OrderSuccess from './OrderSuccess.vue'
import Rooms from './Rooms.vue'
import Schedule from './Schedule.vue'

import ScheduleSuccess from './ScheduleSuccess.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faSearch, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(faCheckCircle, faSearch, faMapMarkerAlt)

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import VueResource from 'vue-resource'
Vue.use(VueResource)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './custom.scss'
import './progress-wizard.min.css'

// validações
import './vee-validate';

const routes = [
    { path: '/:arName', component: App },
    { path: '/order/:templateId', component: Order },
    { path: '/order/step/contacts', component: Contacts },
    { path: '/order/step/email/confirmation', component: EmailConfirmation },
    { path: '/order/step/additional/information', component: AdditionalInformation },
    { path: '/order/step/confirmation', component: OrderConfirmation },
    { path: '/order/step/success', component: OrderSuccess },
    { path: '/order/step/schedule/rooms', component: Rooms },
    { path: '/order/step/schedule/room/:roomId', component: Schedule },
    { path: '/order/step/schedule/success', component: ScheduleSuccess },
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

//Vue.prototype.$serviceUrl = 'http://localhost:8084';
Vue.prototype.$serviceUrl = '/service';

new Vue({ router }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js